import { FC } from 'react';

import NotificationManager from 'bloko/blocks/notificationManager';
import Notification from 'bloko/blocks/notificationManager/Notification';
import NotificationHeading from 'bloko/blocks/notificationManager/NotificationHeading';

import useTrls from 'hooks/translation/useTrls';

import notificationConfig from 'components/Notifications/config';

import { deleteNotification } from 'store/models/notification';
import { useDispatch, useSelector } from 'store/utils';

import 'components/Notifications/ClickmeManager/ClickmeManager.less';

const ClickmeManager: FC = () => {
    const notifications = useSelector((state) => state.notification.notifications);
    const dispatch = useDispatch();
    const trl = useTrls();

    return (
        <NotificationManager>
            {notifications.map((notificationType, index) => {
                const config = notificationConfig[notificationType];
                if (!config) {
                    return null;
                }
                const { kind, title, trl: trlNotification, customComponent, dataQa } = config;
                return (
                    <Notification
                        key={index}
                        kind={kind}
                        onClose={() => dispatch(deleteNotification(index))}
                        autoCloseDelay={10000}
                        autoClose
                    >
                        {title && <NotificationHeading>{trl(title)}</NotificationHeading>}
                        <div data-qa={dataQa}>{customComponent || trl(trlNotification)}</div>
                    </Notification>
                );
            })}
        </NotificationManager>
    );
};

export default ClickmeManager;
